import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

//components
import OneStop from "./../components/Home/OneStop";
import cardImg1 from "./../assets/AirDuctCleaning.webp";
import cardImg2 from "./../assets/before_after_clean.png";
import cardImg3 from "./../assets/cleaning-4.jpg";
import galleryImg4 from "./../assets/HVAC-Cleaning-Costs.jpg";
import galleryImg5 from "./../assets/footerImg.jpg";
import galleryImg6 from "./../assets/download.jpeg";

import {
  emailValidation,
  firstNameValidation,
  noSpaceValidation,
  phoneOnChange,
  phoneValidation,
} from "../validation";

const EMAIL = "Cleanairkelowna@gmail.com";

const faqData = [
  {
    q: "How often should I have my ducts cleaned?",
    a: "We recommend having your air ducts cleaned every 3 to 5 years, or more often if you have pets, allergies, or have recently renovated. Regular cleaning helps maintain good indoor air quality and can improve your system's efficiency.",
  },
  {
    q: "What does duct cleaning include?",
    a: "Our duct cleaning service includes cleaning the supply and return air ducts, registers, grilles, and other components of your forced-air system. We remove dust, debris, and contaminants using professional equipment so your system can circulate cleaner air.",
  },
  {
    q: "How much does duct cleaning cost?",
    a: "Costs depend on the size of your home, the type of system, and the services needed. We offer transparent pricing with no hidden fees. Request a free quote and we will provide a clear estimate before any work begins.",
  },
  {
    q: "Do you offer free estimates or quotes?",
    a: "Yes. We provide free quotes for duct cleaning and dryer vent cleaning. Contact us with your details and we will give you an honest estimate so you know what to expect.",
  },
  {
    q: "Why should I clean my dryer vent?",
    a: "A clogged dryer vent can be a fire hazard and makes your dryer work harder, which shortens its life and increases energy use. Professional dryer vent cleaning removes lint and blockages so your dryer runs safely and efficiently.",
  },
  {
    q: "How long does duct cleaning take?",
    a: "Most residential duct cleaning jobs take a few hours, depending on the size of your home and your system. We can give you a better estimate when you request a quote.",
  },
  {
    q: "Do you serve areas outside Kelowna?",
    a: "Yes. We serve Kelowna and the wider Okanagan Valley. Contact us with your address and we can confirm we service your area.",
  },
  {
    q: "What factors affect the cost of duct cleaning?",
    a: "Factors include the number of vents and returns, the size and layout of your duct system, whether you need dryer vent cleaning as well, and the level of buildup. We assess your situation and provide a clear quote.",
  },
];

const ductCleaningBenefits = [
  {
    icon: "bi bi-gear-wide-connected",
    title: "Better HVAC Efficiency",
    desc: "Clean ducts allow your heating and cooling system to operate more efficiently, thereby improving performance and reducing energy waste.",
  },
  {
    icon: "bi bi-lightning-charge",
    title: "Lowers Energy Bills",
    desc: "Cleaner ducts enable your HVAC systems to run more efficiently. Less strain means less use of energy and lower electricity costs.",
  },
  {
    icon: "bi bi-droplet",
    title: "Reduced Allergens & Irritants",
    desc: "Helps substantially reduce pollen, pet dander, and other airborne particles which can trigger allergies and respiratory discomfort.",
  },
  {
    icon: "bi bi-wind",
    title: "Dust-Free Environment",
    desc: "Removing dust buildup from ductwork helps prevent particles from circulating through your living spaces.",
  },
  {
    icon: "bi bi-cloud-haze",
    title: "Eliminates Odors",
    desc: "Duct cleaning can help remove odors caused by dust, mold, pets, and other contaminants trapped in the duct system.",
  },
  {
    icon: "bi bi-house-heart",
    title: "Improved Indoor Air Quality",
    desc: "Removes dust, allergens, and pollutants from your duct system so the air circulating in your home is cleaner and healthier.",
  },
];

function Home() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState();
  const [message, setMessage] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [isEmailError, setIsEmailError] = useState(false);
  const [isPhonenumberError, setIsPhonenumberError] = useState(false);
  const [faqOpen, setFaqOpen] = useState(null);
  const [showWelcomeNote, setShowWelcomeNote] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowWelcomeNote(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  function openEmailCompose(e) {
    e.preventDefault();
    if (
      firstName.length > 2 &&
      emailValidation(email) &&
      phoneValidation(phonenumber)
    ) {
      const subject = encodeURIComponent(`Quote request from ${firstName} ${lastName}`);
      const bodyLines = [
        `Name: ${firstName} ${lastName}`,
        `Email: ${email}`,
        `Phone: ${phonenumber || ""}`,
        "",
        `Message: ${message || ""}`,
      ];
      const body = encodeURIComponent(bodyLines.join("\n"));
      window.location.href = `mailto:${EMAIL}?subject=${subject}&body=${body}`;
    } else {
      if (!firstNameValidation(firstName)) {
        setIsFirstNameError(true);
      } else if (!emailValidation(email)) {
        setIsEmailError(true);
      } else if (!phoneValidation(phonenumber)) {
        setIsPhonenumberError(true);
      }
    }
  }

  function handleFirstName(e) {
    setIsFirstNameError(false);
    setFirstName(e.target.value);
  }
  function handleLastName(e) {
    setLastName(e.target.value);
  }
  function handleEmail(e) {
    noSpaceValidation(e.target.value) && setEmail(e.target.value);
    setIsEmailError(false);
  }
  function handlePhonenumber(e) {
    setIsPhonenumberError(false);
    phoneOnChange(e.target.value) && setPhonenumber(e.target.value);
  }
  function handleMessage(e) {
    setMessage(e.target.value);
  }

  return (
    <>
      <div className="page-content">
                {/* HERO BANNER */}
        <div
          className="main-bnr style-1"
          style={{
            backgroundImage: `linear-gradient(135deg, rgba(21, 58, 94, 0.88) 0%, rgba(26, 61, 107, 0.85) 50%, rgba(30, 73, 118, 0.88) 100%), url(${cardImg1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 text-center">
                <h1>
                  Professional, Reliable and Efficient Duct/Dryer Vent Cleaning Experts
                </h1>
                <ul className="mb-4 text-white-50 list-unstyled d-flex flex-wrap justify-content-center gap-3" style={{ fontSize: "1.1rem" }}>
                  <li>• Kelowna • West Kelowna</li>
                  <li>• Lake Country • Peachland</li>
                </ul>
                <Link
                  to={"/contact-us"}
                  className="btn space-lg btn-gradient btn-shadow btn-primary"
                >
                  Get a Free Quote
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* 1. WELCOME / ABOUT US */}
        <section className="clearfix section-wrapper1 bg-primary-light" style={{ paddingTop: "3rem" }}>
          <div className="container">
            <div className="content-inner-1 position-relative" style={{ minHeight: "120px" }}>
              <div
                className="text-center position-absolute top-0 start-0 w-100"
                style={{
                  opacity: showWelcomeNote ? 1 : 0,
                  transition: "opacity 2s ease-in-out",
                  pointerEvents: showWelcomeNote ? "auto" : "none",
                }}
              >
                <h2 className="title mb-0">
                  Welcome to <span className="text-primary">Kelowna Duct Cleaning</span>
                </h2>
              </div>
              <div className="text-center">
                <h2 className="title">About Us</h2>
                <p className="mx-auto" style={{ maxWidth: "720px" }}>
                  Kelowna Duct Cleaning is a locally based company dedicated to improving indoor
                  air quality for both homeowners and businesses across Kelowna, West Kelowna,
                  Lake Country and Peachland. Our team of certified technicians specialize in duct
                  and dryer vent cleaning. To learn more about us{" "}
                  <Link to="/about-us" className="text-primary fw-semibold">
                    click here
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 2. SERVICES */}
        <section className="content-inner bg-light icon-section section-wrapper2">
          <div className="container">
            <div className="section-head text-center">
              <h2 className="title">Our Services</h2>
              <p>Kelowna Duct Cleaning offers the following services</p>
            </div>
            <div className="row sp60">
              <OneStop />
            </div>
          </div>
        </section>

        {/* 3. BENEFITS OF DUCT CLEANING */}
        <section className="content-inner bg-white icon-section section-wrapper2">
          <div className="container">
            <div className="section-head text-center m-b50">
              <h2 className="title">Benefits of Duct Cleaning</h2>
            </div>
            <div className="row sp60">
              {ductCleaningBenefits.map((item, ind) => (
                <div className="col-xl-4 col-md-6 m-b60" key={ind}>
                  <div className="icon-bx-wraper style-3 text-center">
                    <div className="icon-content">
                      <div className="icon-media m-b20">
                        <i
                          className={item.icon}
                          style={{ fontSize: "2.5rem", color: "white" }}
                        />
                      </div>
                      <h4 className="title">{item.title}</h4>
                      <p className="m-b0">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 4. WHY US */}
        <section className="content-inner bg-primary-light icon-section section-wrapper2">
          <div className="container">
            <div className="section-head text-center m-b50">
              <h2 className="title">Why Us</h2>
              <p className="m-0">Reasons to choose Kelowna Duct Cleaning for your duct and dryer vent cleaning needs.</p>
            </div>
            <div className="text-center">
              <Link to="/why-us" className="btn btn-primary btn-lg">Learn More</Link>
            </div>
          </div>
        </section>

        {/* 5. GALLERY / OUR WORK PICS */}
        <section className="content-inner bg-white section-wrapper2" id="gallery">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center m-b30">
                <h3 className="title">Gallery</h3>
                <p className="m-0">Professional duct and dryer vent cleaning across Kelowna & the Okanagan.</p>
              </div>
              {[
                { img: cardImg1, alt: "Duct cleaning", caption: "Expert duct cleaning for cleaner air." },
                { img: cardImg2, alt: "Before and after duct cleaning", caption: "Results you can see." },
                { img: cardImg3, alt: "Duct cleaning service Kelowna", caption: "Serving Kelowna & the Okanagan." },
                { img: galleryImg4, alt: "HVAC cleaning", caption: "Thorough HVAC and duct cleaning." },
                { img: galleryImg5, alt: "Duct cleaning service", caption: "Quality service you can trust." },
                { img: galleryImg6, alt: "Duct and vent cleaning", caption: "Clean ducts, healthier air." },
              ].map((item, i) => (
                <div className="col-md-4 col-lg-4 m-b30" key={i}>
                  <div className="card h-100 shadow-sm">
                    <img src={item.img} alt={item.alt} className="card-img-top rounded-top" style={{ width: "100%", height: "220px", objectFit: "cover" }} />
                    <div className="card-body">
                      <p className="card-text mb-0 small">{item.caption}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 6. FAQ */}
        <section className="content-inner bg-light section-wrapper2" id="faq">
          <div className="container">
            <div className="section-head text-center m-b50">
              <h2 className="title">Frequently Asked Questions</h2>
              <p className="m-0">
                Common questions about duct cleaning and our services.
              </p>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="accordion" id="faqAccordion">
                  {faqData.map((item, ind) => (
                    <div className="accordion-item border mb-2 rounded" key={ind}>
                      <h3 className="accordion-header">
                        <button
                          className={`accordion-button ${faqOpen !== ind ? "collapsed" : ""}`}
                          type="button"
                          onClick={() => setFaqOpen(faqOpen === ind ? null : ind)}
                          aria-expanded={faqOpen === ind}
                        >
                          {item.q}
                        </button>
                      </h3>
                      <div className={`accordion-collapse collapse ${faqOpen === ind ? "show" : ""}`}>
                        <div className="accordion-body">
                          {item.a}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 7. REQUEST A QUOTE */}
        <section className="content-inner bg-white section-wrapper2">
          <div className="container">
            <div className="card-body">
              <div className="mb-4">
                <h2 className="mb-0">Request a Quote</h2>
              </div>
              <form className="dzForm" onSubmit={openEmailCompose}>
                <div className="row">
                  <div className="col-xl-6 mb-3 mb-md-4">
                    <input
                      name="dzFirstName"
                      type="text"
                      className="form-control"
                      placeholder="First Name"
                      value={firstName}
                      onChange={handleFirstName}
                    />
                    {isFirstNameError && (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        Please enter a valid first name (at least 2 characters).
                      </p>
                    )}
                  </div>
                  <div className="col-xl-6 mb-3 mb-md-4">
                    <input
                      name="dzLastName"
                      type="text"
                      className="form-control"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={handleLastName}
                    />
                  </div>
                  <div className="col-xl-6 mb-3 mb-md-4">
                    <input
                      name="dzEmail"
                      type="text"
                      className="form-control"
                      placeholder="Email Address"
                      value={email}
                      onChange={handleEmail}
                    />
                    {isEmailError && (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        Please enter a valid email address.
                      </p>
                    )}
                  </div>
                  <div className="col-xl-6 mb-3 mb-md-4">
                    <input
                      name="dzPhoneNumber"
                      type="text"
                      className="form-control"
                      placeholder="Phone Number"
                      value={phonenumber}
                      onChange={handlePhonenumber}
                    />
                    {isPhonenumberError && (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        Please enter a valid phone number.
                      </p>
                    )}
                  </div>
                  <div className="col-xl-12 mb-3 mb-md-4">
                    <textarea
                      name="dzMessage"
                      className="form-control"
                      placeholder="Tell us about your duct cleaning needs (e.g., residential, commercial, dryer vent)"
                      value={message}
                      onChange={handleMessage}
                    ></textarea>
                  </div>
                  <div className="col-xl-12">
                    <button
                      name="submit"
                      type="submit"
                      className="btn btn-primary"
                    >
                      Send
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default Home;
